import { useFeatureFlags } from 'utils/features';

export default function useIframeFeaturesEnabled() {
  return useFeatureFlags('IFRAME_FEATURES');
}
